import React, { useState, useEffect, useContext } from "react";
import useTheme from "./useTheme";
import Price from "./Price";
import Slider from "./Slider";
import AddToCart from "./AddToCart";
import ItemList from "./ItemList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Upload from "./Upload";
import Comments from "./Comments";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { CartProvider } from "../context/CartContext";
import Cart from "./Cart";
import { ProductContext } from "../context/ProductContext";

const Kala = (props) => {
  const [product, setProduct] = useState({});

  const [goldPrice, setGoldPrice] = useState(0);

  const [dolarPrice, setDolarPrice] = useState(0);

  const [sekkePrice, setSekkePrice] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const [productItem, setProductItem] = useContext(ProductContext);

  const [theme, switchTheme] = useTheme();

  useEffect(() => {
    const formData = new FormData();
    formData.append("getKala", 1);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("pkKala", props.kala);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setProduct(data.data[0]);
          setProductItem(data.data);
          setIsLoading(false);
        } else {
          setProductItem([]);
        }
      })
      .catch((e) => {
        console.log(e);
        setProductItem([]);
      });

    const form = new FormData();
    form.append("get_cost_online", 1);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/dataProcess.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setGoldPrice(data.result.geram18.ask);
        setDolarPrice(data.result.dolar.ask);
        const obj = {
          sekkeJadid: data.result["sekke-jad"].ask,
          sekkeGhadim: data.result["sekke-gad"].ask,
          sekkeNim: data.result["sekke-nim"].ask,
          sekkeRob: data.result["sekke-rob"].ask,
          sekkeGerami: data.result["sekke-grm"].ask,
        };
        setSekkePrice(obj);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [props.kala]);

  if (!isLoading) {
    if (props.id === 750040 && parseInt(product.barcodeKar) > 10000) {
      return null;
    } else {
      if (productItem !== null && productItem[0] !== undefined) {
        return (
          <CartProvider>
            <Cart id={props.vitrinCode} isVisitor={0} />
            <div className="container">
              <div className="d-flex justify-content-center container">
                <div key={product.pk}>
                  <div className="card shadow m-4">
                    <div class="row no-gutters">
                      <div className="col-lg-5 col-md-12 col-sm-12">
                        <Slider
                          type={"products"}
                          images={product.images}
                          num={product.img_num}
                          barcode={product.barcode}
                          vitrinCode={props.id}
                        />
                      </div>
                      <div
                        className={
                          theme === "light"
                            ? "card-body col-lg-7 col-md-12 col-sm-12 p-4"
                            : "card-body bg-dark text-white col-lg-7 col-md-12 col-sm-12 p-4"
                        }
                      >
                        <Price
                          product={product}
                          gold={goldPrice}
                          dolar={dolarPrice}
                          sekke={sekkePrice}
                          vitrinCode={props.vitrinCode}
                          type={"bar"}
                        />
                        <h5 className="card-title">{product.kalaName}</h5>
                        {product.tozihat !== null &&
                        product.tozihat.trim() !== "" ? (
                          <h6 className="card-title text-warning">
                            {product.tozihat}
                          </h6>
                        ) : null}
                        <h6>کد : {product.barcodeKar}</h6>
                        {parseFloat(product.darsad_takhfif) > 0 ? (
                          <h6>
                            تخفیف کالا :{" "}
                            {parseFloat(product.darsad_takhfif) + "%"}
                          </h6>
                        ) : null}
                        {product.mark.trim() !== "" &&
                        product.mark.trim() !== "0" ? (
                          <h6>برند : {product.mark}</h6>
                        ) : null}
                        {product.type === "0" ||
                        product.type === "2" ||
                        product.type === "3" ? (
                          <h6>
                            {parseFloat(product.vazn) !== 0
                              ? "وزن تقریبی : " + product.vazn
                              : null}
                          </h6>
                        ) : (
                          <h6>
                            {parseFloat(product.vazn) !== 0
                              ? "وزن : " + product.vazn
                              : null}
                          </h6>
                        )}
                        {/* {ojratDarsad(product)} */}
                        <Price
                          product={product}
                          gold={goldPrice}
                          dolar={dolarPrice}
                          sekke={sekkePrice}
                          vitrinCode={props.vitrinCode}
                        />
                        <AddToCart product={product} />
                        <ItemList pk={product.pk} />
                        <div className="row">
                          {product.link.trim() !== "" ? (
                            <div className="col-3 mt-3">
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                size="2x"
                                color="#5bc0de"
                                onClick={() => window.open(product.link)}
                              />
                            </div>
                          ) : (
                            <div className="col-3"></div>
                          )}
                          <div className="col-6">
                            <Upload
                              barcode={product.barcode}
                              vitrinCode={props.id}
                              type={"productImage"}
                              vitrinImg={product.vitrinCode}
                            />
                          </div>
                          <div className="col-3 mt-3">
                            <Comments
                              pk={product.pk}
                              barcode={product.barcode}
                              vitrinCode={props.id}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  className="btn btn-info shadow"
                  onClick={() => {
                    window.open("https://hamrahvitrin.ir/bonak/?v="+props.vitrinCode , "_self");
                  }}
                >
                  بازگشت به ویترین
                </button>
              </div>
            </div>
          </CartProvider>
        );
      } else {
        return (
          <div className="mt-4 row justify-content-center">محصولی یافت نشد</div>
        );
      }
    }
  } else {
    return (
      <div className="row justify-content-center m-5 p-5">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
};

export default Kala;
